import { ReactNode } from 'react'
import { Anchor, anchoredCSS, LinearTransform, type Rect, type Offset } from '@st/geom'
import { useLinearTransform } from '../use-linear-transform'

type Props = {
  children: ReactNode
  className?: string
  target?: Rect
  targetAnchor?: Anchor
  toolbarAnchor?: Anchor
  toolbarOffset?: Offset
}
// Like geom.anchored, attach a toolbar point to a target point. Without an
// explicit target, the positioned parent is the target. Offsets are page-space;
// inverse scaling keeps controls readable and preserves the attachment point.
export function FloatingToolbar({
  children,
  className,
  target,
  targetAnchor = Anchor.topLeft,
  toolbarAnchor = Anchor.bottomLeft,
  toolbarOffset = { dx: 0, dy: -12 }
}: Props) {
  const transform = useLinearTransform()

  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        ...anchoredCSS({
          target,
          targetAnchor,
          followerAnchor: toolbarAnchor,
          followerOffset: toolbarOffset,
          // The toolbar sits inside the zoomed page. Undo that scaling so its buttons
          // stay the same size on screen as the user zooms in or out.
          followerTransform: LinearTransform.invert(transform)
        })
      }}
      onMouseDown={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
      onDoubleClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      {children}
    </div>
  )
}
